import React, { useEffect, useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Button, Card, MenuItem, Typography } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { Navigate, useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../components/input/inputTextField";
import CheckBoxCustom from "../../../components/checkbox/CheckBoxCustom";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import { colors } from "../../../constants/colors";
import { icons } from "../../../assets/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useDispatch } from "react-redux";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { advisorFormApi } from "../../../api/advisor-form/advisor-form.api";
import { useTranslation } from "react-i18next";
const UpdateEvaluationForm = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const styledIcon = (icon: React.ReactElement) => {
    return React.cloneElement(icon, {
      style: { fontSize: "32px", color: colors.subPrimary },
    });
  };

  const styledIconDelete = (icon: React.ReactElement) => {
    return React.cloneElement(icon, {
      style: { fontSize: "24px", color: colors.red },
    });
  };

  const defaultIcon = styledIcon(<FiberManualRecord />);
  const deleteIcon = styledIconDelete(<CloseIcon />);

  const [singleDataForm, setSingleDataForm] = useState<any>({});
  const [isCanEdit, setIsCanEdit] = useState(false);

  const [inputValue, setInputValue] = useState<any>({
    form_name: "",
    usage_type_selected: "",
    main_form_evaluation: [
      {
        title_evaluation: "",
        evaluation_item: [""],
      },
    ],
  });

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleEvaluationChange = (id: string, status: boolean) => {
    setInputValue({
      ...inputValue,
      usage_type_selected: id,
    });
  };

  // Function to handle adding new cards (evaluations)
  const addEvaluationCard = () => {
    setInputValue((prev: any) => ({
      ...prev,
      main_form_evaluation: [
        ...prev.main_form_evaluation,
        {
          title_evaluation: "",
          evaluation_item: [""],
        },
      ],
    }));
  };

  // Function to handle changing the title of the evaluation
  const handleTitleChange = (index: number, value: string) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[index].title_evaluation = value;
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  // Function to handle adding sub-items within an evaluation card
  const addEvaluationItem = (index: number) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[index].evaluation_item.push("");
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  // Function to handle sub-item change
  const handleItemChange = (
    cardIndex: number,
    itemIndex: number,
    value: string
  ) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[cardIndex].evaluation_item[itemIndex] = value;
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  // Function to remove an evaluation item
  const removeEvaluationCard = (cardIndex: number) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations.splice(cardIndex, 1); // Remove the card at the specified index
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  const removeEvaluationItem = (cardIndex: number, itemIndex: number) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[cardIndex].evaluation_item.splice(itemIndex, 1); // Remove the item at itemIndex
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  function mapInputToApiStructureUpdate(input: any, existingData: any) {
    return {
      advisor_form: {
        id_advisor_form: existingData.id_advisor_form, // Use existing ID
        advisor_form_name: input.form_name, // Update name from input
        is_advisor:
          input.usage_type_selected === "อาจารย์ที่ปรึกษาวิทยานิพนธ์" ? 1 : 0, // i18n-ignore (value comparison)
        is_class_room:
          input.usage_type_selected === "อาจารย์ที่ปรึกษาประจำชั้น" ? 1 : 0, // i18n-ignore (value comparison)
        is_teacher:
          input.usage_type_selected === "อาจารย์ที่ปรึกษาประจำรายวิชา" ? 1 : 0, // i18n-ignore (value comparison)
        status: existingData.status, // Retain existing status
        advisor_form_detail: input.main_form_evaluation.map(
          (evaluation: any, index: number) => {
            // Check if the evaluation already exists in existingData
            const existingEvaluation = existingData.advisor_form_detail[index];
            return {
              id_advisor_form_detail: existingEvaluation
                ? existingEvaluation.id_advisor_form_detail
                : null, // Retain existing ID or set to null
              id_advisor_form: existingData.id_advisor_form, // Reference to the parent form
              advisor_form_detail_name: evaluation.title_evaluation, // Update name from input
              status: existingEvaluation ? existingEvaluation.status : "active", // Retain existing status or set to active
              advisor_form_detail_sub: evaluation.evaluation_item
                .filter((item: any) => item !== "") // Filter out empty items
                .map((item: any, subIndex: number) => {
                  // Check if the sub-item already exists
                  const existingSubItem = existingEvaluation
                    ? existingEvaluation.advisor_form_detail_sub[subIndex]
                    : null;
                  return {
                    id_advisor_form_detail_sub: existingSubItem
                      ? existingSubItem.id_advisor_form_detail_sub
                      : null, // Retain existing sub-item ID or set to null
                    id_advisor_form_detail: existingEvaluation
                      ? existingEvaluation.id_advisor_form_detail
                      : null, // Reference to the parent detail
                    advisor_form_detail_sub_name: item, // Update name from input
                    status: existingSubItem ? existingSubItem.status : "active", // Retain existing status or set to active
                  };
                }),
            };
          }
        ),
      },
    };
  }

  const prepareDataForApi = (data: any) => {
    const nameChecked: string[] = []; // Initialize as an array

    if (data.is_advisor === 1) {
      nameChecked.push("อาจารย์ที่ปรึกษาวิทยานิพนธ์"); // i18n-ignore (state value compared with option id)
    }
    if (data.is_class_room === 1) {
      nameChecked.push("อาจารย์ที่ปรึกษาประจำชั้น"); // i18n-ignore (state value compared with option id)
    }
    if (data.is_teacher === 1) {
      nameChecked.push("อาจารย์ที่ปรึกษาประจำรายวิชา"); // i18n-ignore (state value compared with option id)
    }

    // Join the names into a single string, separated by commas
    return nameChecked.join(", ");
  };

  function mapApiDataToState(apiData: any) {
    return {
      form_name: apiData.advisor_form_name,
      usage_type_selected: prepareDataForApi(apiData),
      main_form_evaluation: apiData.advisor_form_detail.map((detail: any) => ({
        title_evaluation: detail.advisor_form_detail_name,
        evaluation_item: detail.advisor_form_detail_sub.map(
          (sub: any) => sub.advisor_form_detail_sub_name
        ),
      })),
    };
  }

  const getSingleEvaluationForm = async (id: number) => {
    const res = await advisorFormApi.getAdvisorFormById(id);
    const data = res.data;
    if (data.status < 300) {
      setSingleDataForm(data.data);

      setInputValue(mapApiDataToState(data.data));
    } else {
      setSingleDataForm({});
      setInputValue({});
    }
  };

  useEffect(() => {
    if (id) {
      getSingleEvaluationForm(+id);
    }
  }, [id]);

  const handleUpdate = async (id: number, body: any, dataApi: any) => {
    if (body) {
      try {
        dispatch(unsetLoading());

        const newBody = mapInputToApiStructureUpdate(body, dataApi);

        const response = await advisorFormApi.updateAdvisorForm(id, newBody);
        if (response.status < 300) {
          alertSuccess(
            t("แก้ไขแบบฟอร์ม"),
            t("แก้ไขแบบฟอร์ม เรียบร้อยแล้ว"),
            undefined,
            () => {
              setIsCanEdit(false);
              getSingleEvaluationForm(id);
            }
          );
        }
      } catch (error) {
        alertError(t("แก้ไขแบบฟอร์ม ไม่สำเร็จ"));
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  const handleDelete = async (id: number) => {
    if (id) {
      alertActive(
        t("ลบรูปแบบฟอร์ม"),
        t("ท่านต้องการลบรูปแบบฟอร์ม ใช่หรือไม่"),
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await advisorFormApi
            .updateAdvisorFormStatus(+id, "inactive")
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  t("ลบรูปแบบฟอร์ม เรียบร้อย"),
                  undefined,
                  undefined,
                  () => {
                    navigate(routeName.cms.ManageEvaluationForm);
                    setIsCanEdit(false);
                  }
                );
              }
            })
            .catch(() => {
              alertError(t("รูปแบบฟอร์ม ไม่สำเร็จ"));
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  console.log("singleDataForm", singleDataForm);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("จัดการแบบฟอร์มประเมิน"),
            key: "1",
            pathName: routeName.cms.ManageEvaluationForm,
          },
          {
            name: t("แก้ไขแบบฟอร์ม"),
            key: "2",
            pathName: routeName.cms.UpdateEvaluationForm,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{t("แก้ไขแบบฟอร์ม")}</Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
          <InputTextField
            heading={t("ชื่อแบบฟอร์ม")}
            placeholder={t("ระบุชื่อแบบฟอร์ม")}
            value={inputValue.form_name}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValue("form_name", e.target.value)
            }
            disabled={!isCanEdit}
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
          <Typography variant="h6">{t("ใช้สำหรับ")}</Typography>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            {dataEvaluation.map((item, index) => (
              <span
                key={index + 1}
                style={{
                  marginRight: "8rem",
                }}
              >
                <CheckBoxCustom
                  key={item.id}
                  checked={inputValue.usage_type_selected.includes(item.id)}
                  label={t(item.name)}
                  setChecked={(status: boolean) =>
                    handleEvaluationChange(item.id, status)
                  }
                  disabled={!isCanEdit}
                />
              </span>
            ))}
          </div>
        </article>

        {/* Dynamic evaluation cards */}
        {inputValue.main_form_evaluation.map(
          (evaluation: any, cardIndex: number) => (
            <article
              key={cardIndex}
              className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12"
            >
              <Card
                sx={{
                  boxShadow: `0px 5px ${colors.subPrimary}`, // Shadow at the bottom only
                  padding: 2,
                  flexDirection: "row",
                  alignItems: "center",
                  borderRadius: "12px",
                  border: "1px solid #E0E0E0",
                }}
              >
                <InputTextField
                  value={evaluation.title_evaluation}
                  helperText={""}
                  type={"text"}
                  heading={t("หัวข้อหลัก")}
                  placeholder={t("ระบุหัวข้อหลัก")}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleTitleChange(cardIndex, e.target.value)
                  }
                  required
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  inputHeight={"auto"}
                  disabled={!isCanEdit}
                />

                <br />
                <br />

                <Typography variant="h6">{t("หัวข้อย่อย")}</Typography>

                {evaluation.evaluation_item.map(
                  (item: any, itemIndex: number) => (
                    <div
                      key={itemIndex}
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "16px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <span>{defaultIcon}</span>

                      <InputTextField
                        value={item}
                        helperText={""}
                        type={"text"}
                        heading={""}
                        placeholder={t("ระบุหัวข้อย่อย")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleItemChange(
                            cardIndex,
                            itemIndex,
                            e.target.value
                          );

                          // Check if the current item is the last item
                          if (
                            itemIndex ===
                            evaluation.evaluation_item.length - 1
                          ) {
                            addEvaluationItem(cardIndex); // Add a new item if it's the last one
                          }
                        }}
                        borderColor="white"
                        disabled={!isCanEdit}
                      />

                      {isCanEdit && (
                        <>
                          {itemIndex !==
                          evaluation.evaluation_item.length - 1 ? (
                            <span
                              onClick={() =>
                                removeEvaluationItem(cardIndex, itemIndex)
                              }
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {deleteIcon}
                            </span>
                          ) : null}
                        </>
                      )}
                    </div>
                  )
                )}

                {isCanEdit && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginTop: "8px",
                      justifyContent: "end",
                    }}
                  >
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => removeEvaluationCard(cardIndex)} // Call the remove function for the card
                    >
                      <img src={icons.bag_cross} alt="Icon" />
                    </Button>
                  </div>
                )}
              </Card>
            </article>
          )
        )}

        {isCanEdit && (
          <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4 ">
            <ButtonPrimary
              onClick={() => {
                addEvaluationCard();
              }}
              mode="add"
              buttonName={t("เพิ่มคำถาม")}
              btnProps={{
                width: "125px",
                margin: "12px",
              }}
            />
          </article>
        )}
      </div>

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.ManageEvaluationForm);
          }}
          mode="del"
          buttonName={t("ยกเลิก")}
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />

        {isCanEdit && (
          <ButtonPrimary
            onClick={() => {
              if (id) {
                handleUpdate(+id, inputValue, singleDataForm);
              }
            }}
            mode="success"
            buttonName={t("บันทึก")}
            btnProps={{
              width: "125px",
              margin: "12px",
            }}
          />
        )}

        {!isCanEdit && (
          <ButtonPrimary
            onClick={() => {
              setIsCanEdit(true);
            }}
            // mode="success"
            buttonName={t("แก้ไข")}
            btnProps={{
              width: "125px",
              margin: "12px",
            }}
          />
        )}

        {/* {!isCanEdit && (
          <ButtonPrimary
            mode="del"
            onClick={() => {
              if (id) {
                handleDelete(+id);
              }
            }}
            buttonName={"ลบ"}
            btnProps={{
              width: "125px",
              margin: "12px",
            }}
          />
        )} */}
      </section>
    </div>
  );
};

export default UpdateEvaluationForm;
